import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'ark-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  @Input() max: number;
  @Output() pageChange = new EventEmitter<any>();

  config: any;
  
  constructor(
    private route: ActivatedRoute, 
    private router: Router) {
  }

  ngOnInit() {
  }

  onChange(event) {
    this.pageChange.emit(event);
  }

}
